// cardData.js

import Icon1 from '../assets/icons/cardIcon1.svg';
import Icon2 from '../assets/icons/cardIcon2.svg';
import Icon3 from '../assets/icons/cardIcon3.svg';
import Icon4 from '../assets/icons/cardIcon4.svg';
import Icon5 from '../assets/icons/cardIcon5.svg';
import Icon6 from '../assets/icons/cardIcon6.svg';

//Alex aici poti sa schimbi textul si titlul serviciilor de pe home page ( cele 9 containere )

const cardData = [
  
  {
    title: 'Inteligența Artificială',
    text: 'Evaluăm impactul AI în procesele operaționale, oferim ghiduri etice personalizate și gestionăm riscurile, asigurând utilizarea responsabilă a AI și protejarea datelor sensibile.',
    icon: Icon1,
  },
  {
    title: 'Servicii de Training',
    text: 'Organizăm traininguri și workshopuri specializate în protecția datelor și utilizarea etică a AI, contribuind la creșterea competențelor și asigurarea conformității în mediul digitalizat.',
    icon: Icon2,
  },
  {
    title: 'Securitatea Datelor',
    text: 'Identificăm riscurile de securitate și implementăm soluții pentru protecția datelor în mediul IT și AI, asigurând integritatea și securitatea sistemelor în fața amenințărilor cibernetice.',
    icon: Icon3,
  },
  {
    title: 'Date cu caracter Personal',
    text: 'Oferim audituri de conformitate și politici personalizate pentru protecția datelor, asigurând respectarea GDPR în contextul utilizării tehnologiilor AI și IT.',
    icon: Icon4,
  },
  {
    title: 'Whistleblowing',
    text: 'Oferim soluții IT avansate și oferim training pentru a promova transparența și integritatea în companii, în conformitate cu standardele de whistleblowing.',
    icon: Icon5,
  },
  {
    title: 'Privacy și ePrivacy',
    text: 'Evaluăm și optimizăm securitatea cibernetică și confidențialitatea datelor, asigurând conformitatea cu reglementările și protecția eficientă a datelor în contextul digitalizării și utilizării tehnologiilor avansate.',
    icon: Icon6,
  },

];

export default cardData;
